import { useCallback } from "react";
import { axiosUserV2 } from "./axios";

export const useDeleteUserFilterView = () => {
  const [state, execute, cancel] = axiosUserV2<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({
        url: `/filterView/${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
